import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch } from "react-redux";
import { toggleHotKeys } from "../../store/entities/game-controls/hot-keys-slice";
import translate from "../../services/translation/lang";
import soundFxPlayer from "../../services/audio/soundfx-player";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HotkeyModal({ open, handleClose, containerRef, enabled }) {
  const dispatch = useDispatch();
  const handleChange = (event) => {
    dispatch(toggleHotKeys(event.target.checked));
    soundFxPlayer.play("btnClick")
  };
  const closeIcon = "img/close-icon.svg";
  return (
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        container={containerRef.current}
        aria-describedby="alert-dialog-slide-description"
        className="hotkey-modal"
      >
        <div className="modal-title">
          <DialogTitle>{translate('hotkeys')}</DialogTitle>
          <IconButton aria-label="close" onClick={handleClose}>
            <img width={24} height={24} src={closeIcon} alt="close-icon" />
          </IconButton>
        </div>
        <DialogContent>
          <div className="hotkey-checkbox">
            <Checkbox
              checked={enabled}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 32 } }}
            />
            <p className="hotkey-checkbox-info">
              <span>{translate("hotkeys_enabled")}</span>
              {translate("enable_hotkeys_checkbox")}
            </p>
          </div>
          <div className="hotkey-info">
            <p>{translate("drop_ball")}</p><div className="hotkey-key">B</div>
          </div>
          <div className="hotkey-info">
            <p>{translate("double_bet")}</p><div className="hotkey-key">S</div>
          </div>
          <div className="hotkey-info">
            <p>{translate("halve_bet")}</p><div className="hotkey-key">A</div>
          </div>
          <div className="hotkey-info">
            <p>{translate("min_bet")}</p><div className="hotkey-key">D</div>
          </div>
        </DialogContent>
      </Dialog>
  );
}
